"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBonusCreateDto = instanceOfBonusCreateDto;
exports.BonusCreateDtoFromJSON = BonusCreateDtoFromJSON;
exports.BonusCreateDtoFromJSONTyped = BonusCreateDtoFromJSONTyped;
exports.BonusCreateDtoToJSON = BonusCreateDtoToJSON;
exports.BonusCreateDtoToJSONTyped = BonusCreateDtoToJSONTyped;
/**
 * Check if a given object implements the BonusCreateDto interface.
 */
function instanceOfBonusCreateDto(value) {
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    return true;
}
function BonusCreateDtoFromJSON(json) {
    return BonusCreateDtoFromJSONTyped(json, false);
}
function BonusCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amount': json['amount'],
        'description': json['description'] == null ? undefined : json['description'],
        'shiftId': json['shiftId'],
    };
}
function BonusCreateDtoToJSON(json) {
    return BonusCreateDtoToJSONTyped(json, false);
}
function BonusCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amount': value['amount'],
        'description': value['description'],
        'shiftId': value['shiftId'],
    };
}
//# sourceMappingURL=BonusCreateDto.js.map